// [목적] 강원캔버스 border-radius 토큰 (design_structure §3-4)
// [이유] CLAUDE.md §6-3 — 디자인 토큰 강제, radius 직접 입력 금지
// [사이드 이팩트] MUI 테마 shape 파생 / Card / Chip / Button 등 모서리 곡률
// [수정 시 고려사항] s/m/l/xl 4단계 외 추가 시 컴포넌트 매핑 동기화 필요

export const radius = {
  s: 6,
  m: 10,
  l: 16,
  xl: 24,
} as const;

export type RadiusTokens = typeof radius;
export type RadiusKey = keyof typeof radius;
